import type * as ents from '@attain-apps/entities'
import * as graphql from '@attain-apps/fe/web/main/lib/graphql'
import gql from 'graphql-tag'

import * as fragments from '../fragments'

const DOC = gql`
  ${fragments.cluster.DOC}
  mutation UpdateSpaceCluster(
    $tenantId: ID!
    $zoneId: ID!
    $appId: ID!
    $scenarioId: ID!
    $clusterId: ID!
    $input: ClusterUpdateInput!
  ) {
    tenant(id: $tenantId) {
      zone(id: $zoneId) {
        app(id: $appId) {
          scenario(id: $scenarioId) {
            extra {
              space {
                updateCluster(id: $clusterId, input: $input) {
                  ...FragmentSpaceCluster
                }
              }
            }
          }
        }
      }
    }
  }
`

const TRANSFORMER = graphql.transformers.OUT.nonNull(
  graphql.transformers.OUT.select<
    graphql.schema.UpdateSpaceClusterMutation,
    ents.extra.space.Cluster,
    'tenant'
  >(
    'tenant',
    graphql.transformers.OUT.select(
      'zone',
      graphql.transformers.OUT.select(
        'app',
        graphql.transformers.OUT.select(
          'scenario',
          graphql.transformers.OUT.select(
            'extra',
            graphql.transformers.OUT.select(
              'space',
              graphql.transformers.OUT.select(
                'updateCluster',
                fragments.cluster.TRANSFORMER,
              ),
            ),
          ),
        ),
      ),
    ),
  ),
)

export const executor = graphql.createExecutor<
  graphql.schema.UpdateSpaceClusterMutation,
  ents.extra.space.Cluster,
  graphql.schema.UpdateSpaceClusterMutationVariables
>({
  query: DOC,
  transformer: TRANSFORMER,
})
